// extracted by mini-css-extract-plugin
export var cardHolder = "fold-out-menu-module--cardHolder--4c575";